import { useEffect, useMemo, useState } from 'react';
import { onValue, ref } from 'firebase/database';
import { db } from '../config/firebase';

export const usePaymentMethods = (audience) => {
  const [map, setMap] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const methodsRef = ref(db, 'settings/paymentMethods');
    const unsub = onValue(
      methodsRef,
      (snapshot) => {
        setMap(snapshot.val() || {});
        setLoading(false);
      },
      () => {
        setMap({});
        setLoading(false);
      },
    );
    return () => unsub();
  }, []);

  const list = useMemo(() => {
    return Object.entries(map || {})
      .map(([id, value]) => ({ ...value, id: value?.id || id }))
      .sort((a, b) => {
        const orderDiff = (a.order ?? 0) - (b.order ?? 0);
        if (orderDiff !== 0) return orderDiff;
        return String(a.label || '').localeCompare(String(b.label || ''));
      });
  }, [map]);

  const filtered = useMemo(() => {
    if (!audience) return list;
    return list.filter((method) => {
      if (method.enabled === false) return false;
      const audiences = Array.isArray(method.availableFor) ? method.availableFor : [];
      return audiences.includes(audience);
    });
  }, [list, audience]);

  return { list, methods: filtered, loading };
};

export default usePaymentMethods;
